import React, { useEffect, useState, useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Card, CardHeader, Col, Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb.js";
import Axios from "../../lib/Axios.js";

// Register the necessary Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const LookingForAnalytics = () => {
  const [data, setData] = useState([]); // Store labels and IDs
  const [counts, setCounts] = useState([]); // Store counts for each label

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Looking For Analytics",
      },
    },
  };

  const fetchList = async () => {
    try {
      // Fetch the main data for 'lookingFor' and 'lookingForId'
      const result = await Axios.post("/cms/cms-get/looking-for");
      const fetchedData = result?.data?.result?.results || [];
      setData(fetchedData);

      // Fetch counts for each 'lookingForId'
      const countsPromises = fetchedData.map(async (v) => {
        let response 
        if(v.lookingForId){
          response  = await Axios.post("/cms/cms-get/analytics/looking-for-count", {
            lookingForId: v.lookingForId,
          });
        }
        return response?.data?.result?.results || 0;
      });

      const resolvedCounts = await Promise.all(countsPromises);
      setCounts(resolvedCounts);
    } catch (error) {
      console.error("Error fetching analytics data:", error);
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  // Memoize barData to ensure it updates dynamically
  const barData = useMemo(() => {
    return {
      labels: data.map((tag) => tag.lookingFor), // Labels are dynamically generated
      datasets: [
        {
          label: "Number of Users",
          data: counts.length ? counts : [], // Use resolved counts
          backgroundColor: "#33A2EB",
        },
      ],
    };
  }, [data, counts]); // Dependencies for recalculating barData

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Looking For Analytics" />
          <Col lg={12}>
            <Card>
              <CardHeader>
                <h4 className="card-title mb-0">Looking For Analytics</h4>
              </CardHeader>
              <div style={{ padding: "20px" }}>
                {counts.length ? (
                  <Bar data={barData} options={barOptions} />
                ) : (
                  <p>Loading chart...</p>
                )}
              </div>
            </Card>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LookingForAnalytics;
